<template>

    <div class="actual_scores_container container">
        <ActualScore :score_data="scores_data.act_a_1" />
        <ActualScore :score_data="scores_data.act_c_2" />
        <ActualScore :score_data="scores_data.act_t_3" />
        <ActualScore :score_data="scores_data.act_u_4" />
        <ActualScore :score_data="scores_data.act_a_5" />
        <ActualScore :score_data="scores_data.act_l_6" />       
    </div>

</template>

<script>
import ActualScore from './actualScore2'


export default {
    name: 'ActualScores',
    props: ['scores_data'],
    components: {
        ActualScore
    },
    mounted() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
    .actual_scores_container{
        max-width: 1000px;
        padding-top: 50px;
        padding-bottom: 80px;
    }

</style>
